module.exports = __webpack_public_path__ + "static/img/ava2.8ac48b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ava2.png
// module id = 415
// module chunks = 0